module.exports = __webpack_public_path__ + "img/popupcarrier.23108171.png";